import { SVGProps, Ref, forwardRef } from 'react';

export const ShieldFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 23c-2.5-.5-5-2.451-6.5-4.5S3 14 3 11V4l9-3 9 3v7c0 3-1.012 5.5-2.5 7.5s-4 4-6.5 4.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
ShieldFilledSize24Glyph.displayName = 'ShieldFilledSize24Glyph';
